import React, { FC } from 'react';
import styled from '@emotion/styled';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import SvgIcon from '@material-ui/core/SvgIcon';
import StopIcon from '@material-ui/icons/Stop';
import {ShapeSchemeType, MusicPaperShape} from '@consts/types';
import { ReactComponent as ellipseSVG } from '../assets/ellipse.svg';
import { ReactComponent as polygonSVG } from '../assets/polygon.svg';
import { ReactComponent as rectangleSVG } from '../assets/rectangle.svg';
import { ReactComponent as blobSVG } from '../assets/blob.svg';
import { ReactComponent as saveSVG } from '../assets/save.svg';
import { ReactComponent as uploadSVG } from '../assets/upload.svg';
import { ReactComponent as playSVG } from '../assets/play.svg';

type CreateControlGroupProps = {
  selectShape: MusicPaperShape | null;
  isPlayMode: boolean;
  createFigure: (type: ShapeSchemeType) => void;
  removeFigure: (shape: MusicPaperShape) => void;
  openDownloadModal: VoidFunction;
  openUploadModal: VoidFunction;
  setPlayMode: (status: boolean) => void;
}

type CustomIconButtonProps = {
  marginButton?: boolean
}

const CustomIconButton = styled(IconButton)<CustomIconButtonProps>`
  &.MuiIconButton-root {
    background: transparent;
    color: #fff;
    svg {
      fill: transparent;
    }
    &:active {
      background: transparent;
      svg {
        fill: #000;
      }
    }
  }
`;

const DeleteIconButton = styled(IconButton)`;
  &.MuiIconButton-root {
    position: absolute;
    top: -65px;
    background: #f44336;
    color: #fff;
    &:hover {
      background: #d32f2f
    }
  }
`;

const ControlGroupContainer = styled.div`
  top: 50%;
  margin-top: -200px;
  position: absolute;
  left: 15px;
  margin-bottom: -126px;
`;

type ControlSubgroupContainerProps = {
  hasButtonOffset?: boolean;
  withoutExtraPadding?: boolean
}

const ControlSubgroupContainer = styled.div<ControlSubgroupContainerProps>`
  border-radius: 30px;
  padding: ${({ withoutExtraPadding }) => withoutExtraPadding ? '0px' : '10px' } 0px;
  margin-bottom: ${({ hasButtonOffset }) => hasButtonOffset ? '10px' : '0' };
  display: flex;
  flex-direction: column;
  background: #eee;
`;

const ControlGroup: FC<CreateControlGroupProps> = ({
  selectShape,
  isPlayMode,
  createFigure,
  removeFigure,
  openDownloadModal,
  openUploadModal,
  setPlayMode
}) => {
  return (
    <ControlGroupContainer>
      {!!selectShape && (
        <DeleteIconButton onClick={() => removeFigure(selectShape)}>
          <CloseIcon/>
        </DeleteIconButton>
      )}
      <ControlSubgroupContainer hasButtonOffset>
        <CustomIconButton onClick={() => createFigure(ShapeSchemeType.rectangle)}>
          <SvgIcon component={rectangleSVG} viewBox="0 0 28 28" style={{ padding: '1px', boxSizing: 'border-box' }}/>
        </CustomIconButton>
        <CustomIconButton onClick={() => createFigure(ShapeSchemeType.ellipse)}>
          <SvgIcon component={ellipseSVG} viewBox="0 0 32 31"/>
        </CustomIconButton>
        <CustomIconButton onClick={() => createFigure(ShapeSchemeType.blob)}>
          <SvgIcon component={blobSVG} viewBox="0 0 42 40"/>
        </CustomIconButton>
        <CustomIconButton onClick={() => createFigure(ShapeSchemeType.polygon)}>
          <SvgIcon component={polygonSVG} viewBox="0 0 44 42"/>
        </CustomIconButton>
      </ControlSubgroupContainer>
      <ControlSubgroupContainer hasButtonOffset>
        <CustomIconButton onClick={() => openDownloadModal()}>
          <SvgIcon
            component={saveSVG}
            viewBox="0 0 42 40"
            style={{
              fill: 'transparent',
              padding: '1px',
              boxSizing: 'border-box'
            }}
          />
        </CustomIconButton>
        <CustomIconButton onClick={() => openUploadModal()}>
          <SvgIcon component={uploadSVG} viewBox="0 0 46 41" style={{ fill: 'transparent' }}/>
        </CustomIconButton>
      </ControlSubgroupContainer>
      <ControlSubgroupContainer withoutExtraPadding>
        <IconButton onClick={() => setPlayMode(!isPlayMode)}>
          {!isPlayMode && (<SvgIcon component={playSVG} viewBox="0 0 48.11 48.11"/>)}
          {isPlayMode && (<StopIcon style={{ color: '#000' }} />)}
        </IconButton>
      </ControlSubgroupContainer>
    </ControlGroupContainer>
  )
}

export default ControlGroup;